import $ from 'jquery';
import { ICheckboxViewTemplateData } from './interface';

const template = require('./view/checkboxView.handlebars');
const CHECKBOX_SELECTOR = '.fancy-checkbox';

export class CheckboxUI {
    // Store the current active/inactive status
    public active: boolean = this.getChecked();

    public id: string = "c" + this.createRandomId();

    private html: string = "";

    public constructor(public $base: JQuery, public index: number) {
        if (this.getChecked()) {
            this.setActive();
        } else {
            this.setInactive();
        }
        this.html = this.$base.html();
        this.$base.data('index', index);
    }

    public destroy() {
        return this.$base.html(this.html);
    }

    public setActive() {
        this.active = true;
        this.$base
            .find("input")
            .first()
            .attr("checked", "checked")
            .val("1");
        this.$base.addClass("is-active");
    }

    public setInactive() {
        this.active = false;
        this.$base
            .find("input")
            .first()
            .val("0")
            .removeAttr("checked");
        this.$base.removeClass("is-active");
    }

    public getChecked(): boolean {
        if (this.getValue() === "1") {
            return true;
        } else {
            return false;
        }
    }

    public toggle(onChange: () => {}) {
        if (this.active) {
            this.setInactive();
            onChange();
        } else {
            this.setActive();
            onChange();
        }
    }

    public listen(onChange: () => {}): void {
        this.$base
            .find("input")
            .first()
            .on("change", e => {
                this.toggle(onChange);
            });
    }

    public render() {
        return new Promise<void>(resolve => {
            const templateData: ICheckboxViewTemplateData = { name: this.getName(), label: this.getLabelText(), checked: this.getChecked(), id: this.id, index: this.index };
            this.$base.html(template(templateData));
            resolve();
        });
    }

    private createRandomId(): string {
        const S4 = function () {
            return (((1 + Math.random()) * 0x10000) | 0)
                .toString(16)
                .substring(1);
        };
        return S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
    }

    /**
     * Get the name of the inputfield
     * @return the name of the input - string
     */
    private getName(): string {
        const select = this.$base.find("input")[0];
        return select.getAttribute("name");
    }

    /**
     * Get the labeltext
     * @return the text of the <label> element
     */

    private getLabelText(): string {
        const label = this.$base.find("label")[0];
        return label.innerHTML;
    }

    private getValue(): string {
        return this.$base
            .find("input")
            .first()
            .val() as string;
    }

    /**
     * Get the id
     * @return the text of the id attribute
     */
    private getId(): string {
        if (this.$base.find("input").length > 0) {
            const id = this.$base
                .find("input")[0]
                .getAttribute("id") as string;
            return id;
        }
        return null;
    }

  /**
   * Returns the value of an attribute of the base element (not the input)
   *
   * @param name
   */
  public getBaseAttribute(name: string): string {
      return this.$base.attr(name);
    }
}

/**
 * Return checkboxUI component UI instances
 */

export function createCheckboxUI(extend: boolean) {
    const $base = $(CHECKBOX_SELECTOR);
    let uiInstances: CheckboxUI[] = [];

    $base.each((index, el) => {
        if ($(el).find('.fancy-checkbox__switch').length == 0) {
            uiInstances.push(new CheckboxUI($(el), index));
        }
    });

    return uiInstances;
}
